<template>
  <v-currency-field
      :allow-negative="false"
      v-model="model"
      :auto-decimal-mode="$vuetify.breakpoint.smAndUp ? false : true"
      :decimal-length="nbOfDecimal"
      :dense="dense"
      :max="maxValue"
      :min="0"
      :placeholder="placeholder"
      :rules="required ? [value => !!value || requiredErrorMessage] : []"
      :error-messages="errorMessages"
      :style="'width:' + width"
      :suffix="showSuffix && nbOfDecimal === 0? ',00' : ''"
      append-icon="€"
      class="currency-inputfield pt-0"
      locale="de-DE"
      ref="currField"
      prepend-inner-icon="icon-money"
      @click="clearInput"
      @blur="$emit('blur')"
      @input="(val) => $emit('input', val || 0)"
      @error="err => $emit('error',err)"
  />
</template>

<script>
export default {
  name: "finCurrencyField",
  props: {
    value: {
      type: Number,
      default: 0
    },
    nbOfDecimal: {
      type: Number,
      default: 2
    },
    showSuffix: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "Betrag in Euro"
    },
    width: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    requiredErrorMessage: {
      type: String,
      default: "Gib bitte einen Betrag ein"
    },
    maxValue: {
      type: Number,
      default: undefined
    },
    dense: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: String,
      default: undefined
    }
  },
  data(){
    return {
      //Important du bind any model, otherwise the field will not work probably
      model:0,
    }
  },
  methods: {
    input(val){
      console.log('input',val)
    },
    error(val){
      console.log('error',val)
    },
    clearInput() {
      if (this.value === 0) {
        this.$refs.currField.setValue(undefined)
      }
    }
  },
  watch: {
    // instead of :value="value", re-add if bug of v-currency-field is fixed + remove watch
    // because the initial formatting doesn't work
    value: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.currField.setValue(val)
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.currency-inputfield {

  ::v-deep {

    input {
      text-align: end !important;
    }

    .v-input__slot {
      padding: 10px;
      box-shadow: $fin-color-shadow;
      border: solid 1px #cfd1d3;
      background-color: #ffffff;
    }

    .v-text-field__suffix {
      padding-left: 0;
      color: black;
    }
    .v-text-field__details {
      padding: 0 12px;
    }

  }
}
</style>
